import { AcademyBasePage } from '../../../Modules/Academy/AcademyBasePage';
import { AccountPage } from '../../../Modules/Base/Account/Account';
import { ComingSoonPage } from '../../../Modules/ComingSoon/dashboardPage';
import { SupportTickets } from '../../../Modules/Common/Support/SupportTickets';
import { UserActivityTracking } from '../../../Modules/Base/UserManagement/UserActivityTracking/UserActivityTracking';
import { DashboardBasePage } from '../../../Modules/Dashboard/DashboardBasePage';
import { AllNotesPage } from '../../../Modules/EmploymentEquity/AllNotes/AllNotesPage';
import { CommitteeBase } from '../../../Modules/EmploymentEquity/Committee/CommitteeBase';
import { Consolidation } from '../../../Modules/EmploymentEquity/Consolidation/Consolidation';
import { DocumentRepoBasePage } from '../../../Modules/EmploymentEquity/DocumentRepo/DocumentRepoBasePage';
import { EmployeeStructureBasePage } from '../../../Modules/EmploymentEquity/EmployeeStructure/EmployeeStructureBasePage';
import { GeneralInformation } from '../../../Modules/EmploymentEquity/GeneralInformationPage/GeneralInformation';
import { EEPlan } from '../../../Modules/EmploymentEquity/Plan/EEPlanBase';
import { EEReportingBase } from '../../../Modules/EmploymentEquity/Reporting/EEAReporting/EEReportingBase';
import { EEA2Base } from '../../../Modules/EmploymentEquity/WorkforceProfile_EEA2/EEA2BasePage';
import { EEA4Base } from '../../../Modules/EmploymentEquity/WorkforceProfile_EEA4/EEA4_BasePage';
import { EmploymentEquityBase } from '../../../Modules/EmploymentEquity/ee';
import { BEEForum } from '../../../Modules/Forum/BEEForum';
import { GroupDataManagementBase } from '../../../Modules/GroupDataManagement/GroupDataManagementMain';
import { ClientHomePage } from '../../../Modules/Home/Client/ClientHomePage';
import { VerificationHomePage } from '../../../Modules/Home/VerificationAgency/VerificationHomePage';
import { BeeLegislationResourcesPage } from '../../../Modules/Legislation/BeeLegislationResourcesPage';
import { EELegislationResourcesPage} from '../../../Modules/Legislation/EELegislationResourcesPage';
import { WspAtrLegislationResourcesPage } from '../../../Modules/Legislation/WspAtrLegislationResourcesPage';
import { NewsBase } from '../../../Modules/News/NewsBase';
import { PeopleBase } from '../../../Modules/PeopleDatabase/peopleBase';
import { ClientManagementBase } from '../../../Modules/VerificationAgency/ClientManagementBase';
import { DetailsBase } from '../../../Modules/VerificationAgency/Details/DetailsBase';
import { FeedbackBase } from '../../../Modules/VerificationAgency/Feedback/FeedbackBase';
import { VAClientScorecards } from '../../../Modules/VerificationAgency/Scorecards/Scorecards';
import { Status } from '../../../Modules/VerificationAgency/Status/Status';
import { VAOpenScorecardHomepage } from '../../../Modules/VerificationAgency/VerificationAgencyHomePage/VAOpenScorecardHomePage';
import { WhatsNewPage } from '../../../Modules/WhatsNew/WhatsNewPage';
import config from '../../../config';
import {
	AdvancedSupplierModuleRole,
	BEEAdvisoryRole,
	EEAdvisoryRole,
	AuditRole,
	BEE123SalariesRole, ClientAdminRole,
	ClientRole,
	EE123PeopleRole_Edit,
	EE123PeopleRole_View,
	EE123Role,
	EE123SalariesRole,
	PeopleEditRole,
	PeopleViewRole,
	PlatformPeopleEditRole,
	PlatformPeopleViewRole,
	ScorecardAdmin,
	SiteAdminRole,
	StrategicRelationshipManagerRole,
	SubAdminRole,
	UserAdminRole,
	VAExportEditRole,
	VAUser
} from './UserRoles';

//External redirects
import { IncomingBasePage } from '../../../Modules/BEEScorecards/Incoming/IncomingBase';
import { ScorecardLicenseMain } from '../../../Modules/BEEScorecards/ScorecardLicenses/ScorecardLicenseMain';
import { VerificationScorecardBasePage } from "../../../Modules/BEEScorecards/ScorecardLicenses/VerificationScorecardBasePage";
import { UserManagementBase } from '../../../Modules/Base/UserManagement/UserManagementBase';
import { CentralDataManagementBase } from '../../../Modules/CentralDataManagement/CentralDataManagementBase';
import { CentralDataManagementImportBase } from '../../../Modules/CentralDataManagement/CentralDataManagementImportBase';
import { CustomScorecardSettingsPage } from '../../../Modules/CustomScorecardSettings/CustomScorecardSettingsPage';
import { OrganisationPage } from '../../../Modules/Organisations/Organisation';
import { OrganisationPeoplePage } from '../../../Modules/Organisations/PeopleAndTraining/OrganisationPeople';
import { OrganisationTraining } from '../../../Modules/Organisations/PeopleAndTraining/Training/OrganisationTraining';
import { CommisionerDetails } from '../../../Modules/VerificationAgency/Applications/Commisioner/CommisionerDetails';
import { FinancialInformationDetails } from '../../../Modules/VerificationAgency/Applications/FinancialInformation/FinancialInformationDetails';
import { Proposals } from '../../../Modules/VerificationAgency/Applications/Proposals/Proposals';
import { RiskAssessment } from '../../../Modules/VerificationAgency/Applications/RiskAssessment/RiskAssessment';
import { ServiceRequired } from '../../../Modules/VerificationAgency/Applications/ServiceRequired/ServiceRequired';
import { SampleMethodologyHomepage } from '../../../Modules/VerificationAgency/SampleMethodologyHomePage/SampleMethodologyHomePage';
import { VAMethodologyHomePage } from '../../../Modules/VerificationAgency/VaMethodology/VAMethodologyBasePage';
import { VALockedScorecardHomepage } from '../../../Modules/VerificationAgency/VerificationAgencyHomePage/VALockedScorecardHomePage';
import { VerificationProcessBase } from '../../../Modules/VerificationAgency/VerificationProcess/VerificationProcessBase';
import { WSPDashboardBasePage } from '../../../Modules/WSP/Dashboard/WSPDashboardBasePage';
import { OFOCodesCategorisationPage } from '../../../Modules/WSP/OFOCodesCategorisations/OFOCodesCategorisations';
import { OganisationDetailsPage } from '../../../Modules/WSP/Organisations/OganisationDetailsPage';
import { MerSETAReport } from '../../../Modules/WSP/Report/MerSETAReport';
import { WSPScorecardPage } from '../../../Modules/WSP/Scorecards/ScorecardLicenseModal/WSPScorecards';
import { WorkforceProfilePage } from '../../../Modules/WSP/WorkforceProfile/WorkforceProfile';
import { DocumentRepoSectionModuleTypes } from '../../Model/Enum/BEE123Enums';
import { VerificationAgencyClientApplicationPage } from "../../../Modules/VerificationAgency/Applications/VerificationAgencyClientApplicationsPage";
import { ImportManagementHistory } from '../../../Modules/VerificationAgency/VerificationProcess/VAClientImportManagement/ImportManagementHistory';
import { ImportDetails } from '../../../Modules/VerificationAgency/VerificationProcess/VAClientImportManagement/ImportDetails';
import { MultiPageImport } from '../../../Modules/VerificationAgency/VerificationProcess/VAClientImportManagement/MultiPageImport';
import { Reports } from '../../../Modules/VerificationAgency/VerificationProcess/Scorecard Outcome/Reports';
import { Certificates } from '../../../Modules/VerificationAgency/VerificationProcess/Scorecard Outcome/Certificates';
import { FileManagementBase } from '../../../Modules/VerificationAgency/VerificationProcess/VAClientImportManagement/FileManagement/FileManagementBase';
import { VerificationHubDashboard } from '../../../Modules/VerificationAgency/VerificationHub/VerificationHubDashboard';
import { ClientRegistrations } from '../../../Modules/Advisory/ClientRegistrations/ClientRegistrations';
import { ClientScorecards } from '../../../Modules/Advisory/ClientScorecards/ClientScorecards';
import { GroupImportsBase } from '../../../Modules/EmploymentEquity/GroupImports/GroupImportsBase';
import { ReportBase } from '../../../Modules/EmploymentEquity/Reporting/ReportBase';
import { VAExcelExports } from '../../../Modules/VerificationAgencyExcelExports/VAExcelExports';
import { PayrollConnections } from '../../../Modules/Organisations/PayrollConnections/PayrollConnections';
import { OrganisationLinkedScorecards } from '../../../Modules/Organisations/LinkedScorecards/OrganisationLinkedScorecards';
import { Divisions } from '../../../Modules/Organisations/Divisions/Divisions';
import { PayrollRequests } from '../../../Modules/Organisations/PayrollImports/PayrollRequests';
import {PayrollImport} from "../../../Modules/CentralDataManagement/Imports/PayrollImport/PayrollImport";
import { PayrollImportHistory } from '../../../Modules/Organisations/PayrollImports/PayrollImportHistory';
import { PayrollImportDetails } from '../../../Modules/CentralDataManagement/Imports/PayrollImport/PayrollImportDetails';
import { LegacyBEEPage } from '../Components/LegacyBEEPage/LegacyBEEPage';

export interface AccountRoutes {
	path: string;
	iconClass: string;
	className: string;
	MenuAbv: string;
	MenuItemName: string;
	Component: any;
	layout: string;
	userRoleIncludes?: string[];
	userRoleExcludes?: string[];
}
export interface ProtectedRoute {
	path?: string;
	name: string;
	icon: string;
	Component?: any;
	layout?: string;
	collapse?: boolean;
	state?: string;
	views?: RouteView[];
	isExternal: boolean;
	isConsolidatedRoute?: boolean;
	userRoleIncludes?: string[];
	userRoleExcludes?: string[];
	visible?: boolean;
	hasChildren?: boolean;
	isAPIExternal?: boolean;
	componentProps?: {};
}
export interface RouteView {
	path: string;
	name: string;
	mini?: string;
	Component: any;
	componentProps?: {};
	visible?: boolean;
	layout: string;
	subLevel?: boolean;
	userRoleIncludes?: string[];
	userRoleExcludes?: string[];
	isExternal?: boolean;
	collapse?: boolean;
	state?: string;
	views?: RouteView[];
	isAPIExternal?: boolean;
}

export const portal = '/';
export const ExternalMain = '/www.bee123.co.za/';
export const eeScorecardRoute = 'ee/scorecard/:scorecardId/';
export const WSPScorecard = 'wsp/scorecard/:WSPScorecardId/';
export const organisation = 'organisation/';
export const bbbeeScorecardRoute = 'bee/scorecard/:BBBEEScorecardId/';
export const advisory = 'advisory/'

export const verificationAgency = {
	clientManagement: 'clientManagement',
	company: 'company',
	details: 'details',
	applications: 'applications',
	proposals: 'proposals',
	scorecards: 'scorecards',
	feedback: 'feedback',
	riskAssessment: 'riskAssessment',
	status: 'status',
	notifications: 'notifications',
};

export const eeModule = {
	ee: 'ee',
	base: 'base',
	plan: 'plan',
	objectives: 'objectives',
	workforceProfile: 'workforceProfile',
	employeeStructure: 'employeeStructure',
	legislation: 'legislation',
	documentRepo: 'documentRepository',
	academy: 'academy',
	forum: 'forum',
	groupImports: 'groupImports'
};

export const wspModule = {
	wsp: 'wsp',
	base: 'base',
	WSPScorecard: WSPScorecard,
	Dashboard: WSPScorecard + 'Dashboard',
	OFOCodesCategorisation: WSPScorecard + 'OFOCodesCategorisation',
	OrganisationDetails: WSPScorecard + 'Organisation',
	WorkforceProfile: WSPScorecard + 'WorkforceProfile',
	MerSETAReport: WSPScorecard + 'MerSETAReport'
};

export const organisationModule = {
	organisation: organisation,
	people: organisation + 'people',
	training: organisation + 'training',
	person: organisation + 'people/person',
	payrollConnections: organisation + 'payrollConnections',
	linkedScorecards: organisation + 'linkedScorecards',
	divisions: organisation + 'divisions',
	payrollData: organisation + 'payrollData',
	payrollImportDetails: organisation + 'payrollData/details'
};

export const vaBBBEEmodule = {
	scorecardManagement: 'scorecardManagement',
	administrator: 'administrator',
	incoming: 'incoming',
	scorecardSubmissions: 'scorecardSubmissions',
	accessRequests: 'accessRequests',
	dataPageSubmissions: 'dataPageSubmissions'

};

export const vaBBBEEVerificationHub = {
	scorecardManagement: 'scorecardManagement',
	dashboard: 'vaDashboard'
};

export const advisoryModule = {
	manageEmployees: advisory + 'manage',
	clientRegistrations: advisory + 'clientRegistrations',
	clientBEEScorecards: advisory + 'bee/clientScorecards/:registrationId/:registrationName',
	clientEEScorecards: advisory + 'ee/clientScorecards/:registrationId/:registrationName',
};

export const bbbeeModule = {
	bee: 'bee',
	scorecardLicense: 'scorecardLicense',
	groupDataManagementModule: 'groupDataManagementModule',
	directoryListings: 'directoryListings',
	customScorecardSettings: 'customScorecardSettings',
	verificationScorecards: 'verificationScorecards',
	verificationProcess: 'verificationProcess',
	plannerAndTracker: 'plannerAndTracker',
	elements: 'elements',
	reports: 'reports',
	certificates: 'certificates',
	importManagementHistory: 'importManagementHistory',
	importDetails: 'importDetails',
	importPage: 'importPage',
	fileManagement: 'fileManagement',
	fileIntergrationManagement: 'management',
	verificationAgencyExcelExports: 'verificationAgencyExcelExports'
};

export const eeScorecard = {
	dashboard: eeScorecardRoute + 'dashboard',
	generalInformation: eeScorecardRoute + 'general',
	employeeStructure: eeScorecardRoute + 'structure',
	eePlan: eeScorecardRoute + 'eePlan',
	workforceProfile: eeScorecardRoute + 'workforceProfile',
	remuneration: eeScorecardRoute + 'remuneration',
	eeCommittee: eeScorecardRoute + 'committee',
	reporting: eeScorecardRoute + 'reporting',
	eeaReporting: eeScorecardRoute + 'eeaReporting',
	employeeSalaries: eeScorecardRoute + 'salaries',
	notes: eeScorecardRoute + 'notes',
	consolidation: eeScorecardRoute + 'consolidation',
	employeeHeadcountDashboard: 'EmployeeHeadcount',
	incomeDifferentialsDashboard: 'IncomeDifferentials',
	eePlanTrackingDashboard: 'PlanTracking'
};

export const people = {
	database: 'Database',
	salaries: 'Salaries',
};

export const ClientRoutes = (hasWSPScorecards: boolean, enabledPayrollIntegration: boolean): ProtectedRoute[] => {
	return [
		{
			path: 'home',
			name: 'Home',
			icon: 'nc-icon nc-app',
			Component: ClientHomePage,
			layout: portal,
			isExternal: false,
			userRoleExcludes: [ClientRole],
		},
		{
			path: 'organisations',
			name: 'Organisations',
			icon: 'nc-icon nc-bank',
			Component: OrganisationPage,
			layout: portal,
			isExternal: false,
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards || enabledPayrollIntegration,
			userRoleIncludes: [UserAdminRole, SubAdminRole, PeopleEditRole, EE123PeopleRole_Edit, BEE123SalariesRole, EE123SalariesRole, PlatformPeopleViewRole],
            userRoleExcludes: [ClientRole]
		},
		{
			name: 'Data Warehouse',
			icon: 'nc-icon nc-credit-card',
			state: 'peopleCollapse',
			collapse: true,
			isExternal: false,
			visible: config.enable_central_management === 'false',
			userRoleExcludes: [ClientRole],
			views: [
				{
					path: `people/${people.database}`,
					name: 'People Repository',
					mini: 'PR',
					Component: PeopleBase,
					layout: portal,
				},
				{
					path: `people/${people.salaries}`,
					name: 'People Salaries',
					mini: 'PS',
					Component: PeopleBase,
					layout: portal,
					userRoleIncludes: [EE123SalariesRole, BEE123SalariesRole],
				},
			],
		},
		{
			name: 'Central Data Management',
			icon: 'nc-icon nc-credit-card',
			state: 'centalDataManagementCollapse',
			collapse: true,
			isExternal: false,
			visible: config.enable_central_management === 'true',
			userRoleExcludes: [ClientRole, VAUser],
			userRoleIncludes: [PeopleEditRole, PeopleViewRole, EE123SalariesRole, BEE123SalariesRole, EE123PeopleRole_Edit, EE123PeopleRole_View],
			views: [
				{
					path: `import/payroll`,
					name: 'Payroll Imports',
					mini: 'PI',
					Component: PayrollImport,
					layout: portal,
					visible: enabledPayrollIntegration,
					userRoleIncludes: [PeopleEditRole, EE123SalariesRole, BEE123SalariesRole, EE123PeopleRole_Edit],
				},
				{
					path: `import/manual`,
					name: 'Manual Imports',
					mini: 'IM',
					Component: CentralDataManagementImportBase,
					layout: portal,
					userRoleIncludes: [PeopleEditRole, EE123SalariesRole, BEE123SalariesRole, EE123PeopleRole_Edit],
				},
				{
					path: `central`,
					name: 'Summaries',
					mini: 'SU',
					Component: CentralDataManagementBase,
					layout: portal,
					userRoleIncludes: [PeopleEditRole, PeopleViewRole, EE123SalariesRole, BEE123SalariesRole, EE123PeopleRole_Edit, EE123PeopleRole_View],
				},
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.fileManagement}`,
					name: 'File Integration Management',
					mini: 'FI',
					Component: LegacyBEEPage,
					componentProps: {
						legacyRoute: 'externalImports/management',
						additionalParams: "hideNav=true&hideFooter=true&hidePageTitle=true",
						pageTitle: "File Integration Management",
					},
					layout: portal,
				},
				{
					path: `import/payrollDetails/:useSignalR`,
					name: 'Payroll Imports Details',
					mini: 'PI',
					Component: PayrollImportDetails,
					layout: portal,
					visible: false,
				},
			],
		},
		{
			path: 'main',
			name: 'B-BBEE Module',
			icon: 'nc-icon nc-paper',
			Component: config.publicUrl,
			visible: config.enable_react_migration === 'false',
			layout: portal,
			isExternal: true,
		},
		{
			path: 'main',
			name: 'B-BBEE Module',
			icon: 'nc-icon nc-paper',
			Component: config.publicUrl,
			visible: config.enable_react_migration === 'true',
			layout: portal,
			isExternal: true,
			collapse: true,
			state: 'beeCollapse',
			userRoleExcludes: [ClientRole],
			views: [
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.scorecardLicense}`,
					name: 'Scorecard Licenses',
					mini: 'SL',
					Component: ScorecardLicenseMain,
					layout: portal,
					visible: config.enable_react_migration === 'true',
				},
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.groupDataManagementModule}`,
					name: 'Group Data Management Module',
					mini: 'GM',
					Component: GroupDataManagementBase,
					layout: portal,
					visible: config.enable_react_migration === 'true',
				},
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.verificationAgencyExcelExports}`,
					name: 'VA Excel Exports',
					mini: 'VE',
					Component: VAExcelExports,
					layout: portal,
					visible: config.enable_va_excel_exports === 'true',
					userRoleIncludes: [VAExportEditRole]
				},
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.directoryListings}`,
					name: 'Directory Listings',
					mini: 'DL',
					Component: `${config.publicUrl}#myBEE123Homepage/listings`,
					layout: portal,
					visible: config.enable_react_migration === 'true',
					isExternal: true
				},

				{
					path: `${bbbeeModule.bee}/${bbbeeModule.customScorecardSettings}`,
					name: 'Custom Scorecard Settings',
					mini: 'SS',
					Component: CustomScorecardSettingsPage,
					layout: portal,
					visible: config.enable_react_migration === 'true',
				}
			],
		},
		{
			name: 'Create BEE Scorecard',
			icon: '',
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'CreateBEEScorecardCollapse',
			visible: false,
			views: [
				{
					path: `${bbbeeScorecardRoute}createscorecard`,
					name: 'Create BEE Scorecard',
					mini: 'CS',
					Component: LegacyBEEPage,
					componentProps: {
						legacyRoute: 'createscorecard/{ScorecardId}',
						pageTitle: 'Create BEE Scorecard',
						navigateTo: (hash: string) => {
							const match = hash.match(/[#/]scorecard\/([^/?]+)/);
							return match ? `/bee/scorecard/${match[1]}/summary/dashboard` : null;
						}
					},
					layout: portal,
					visible: false
				},
			],
		},
				{
			name: 'Create BEE Consolidated Scorecard',
			icon: '',
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'CreateBEEConsolidatedScorecardCollapse',
			visible: false,
			views: [
				{
					path: `${bbbeeScorecardRoute}createconsolidations`,
					name: 'Create BEE Consolidated Scorecard',
					mini: 'CS',
					Component: LegacyBEEPage,
					componentProps: {
						legacyRoute: 'createconsolidations/manage/{ScorecardId}',
						pageTitle: 'Create BEE Consolidated Scorecard',
						navigateTo: (hash: string) => {
							const consolidationsMatch = hash.match(/[#/]consolidations\/manage\/([^/?]+)/);
							if (consolidationsMatch) return `/bee/scorecard/${consolidationsMatch[1]}/consolidationsmanagement`;
							const scorecardMatch = hash.match(/[#/]scorecard\/([^/?]+)/);
							return scorecardMatch ? `/bee/scorecard/${scorecardMatch[1]}/summary/dashboard` : null;
						}
					},
					layout: portal,
					visible: false
				},
			],
		},
		{
			name: 'BEE Consolidations Management',
			icon: '',
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'BEEConsolidationsManagementCollapse',
			visible: false,
			views: [
				{
					path: `${bbbeeScorecardRoute}consolidationsmanagement`,
					name: 'BEE Consolidations Management',
					mini: 'CM',
					Component: LegacyBEEPage,
					componentProps: {
						legacyRoute: 'consolidations/manage/{ScorecardId}',
						pageTitle: 'Consolidations Management',
						navigateTo: (hash: string) => {
							const match = hash.match(/[#/]scorecard\/([^/?]+)/);
							return match ? `/bee/scorecard/${match[1]}/summary/dashboard` : null;
						}
					},
					layout: portal,
					visible: false
				},
			],
		},
		{
			path: 'bbeeVerificationHub',
			name: 'B-BBEE Verification Hub',
			icon: 'nc-icon nc-layout-11',
			layout: portal,
			isExternal: true,
			collapse: true,
			state: 'bbbeeVerificationHubCollapse',
			visible: config.enable_VAScorecardSubmissionProccess === 'true',
			userRoleExcludes: [ClientRole],
			views: [
				{
					path: `${vaBBBEEVerificationHub.dashboard}`,
					name: 'Dashboard',
					mini: 'DA',
					Component: VerificationHubDashboard,
					layout: portal,
					userRoleIncludes: [UserAdminRole],
				},
				{
					path: `${bbbeeModule.bee}/${bbbeeModule.verificationScorecards}`,
					name: 'Verification Scorecards',
					mini: 'VS',
					Component: VerificationScorecardBasePage,
					layout: portal,
					collapse: true,
					views: [
						{
							path: `${bbbeeModule.bee}/${bbbeeModule.verificationScorecards}/Accepted`,
							name: 'Accepted',
							mini: 'AC',
							Component: VerificationScorecardBasePage,
							layout: portal,
						},
						{
							path: `${bbbeeModule.bee}/${bbbeeModule.verificationScorecards}/Submitted`,
							name: 'Submitted',
							mini: 'SU',
							Component: VerificationScorecardBasePage,
							layout: portal,
						},
					]
				},
			],
		},
		{
			path: eeModule.ee,
			name: 'EE Module',
			icon: 'nc-icon nc-circle-10',
			Component: EmploymentEquityBase,
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'eeCollapse',
			userRoleIncludes: [UserAdminRole, SubAdminRole, EE123Role],
			userRoleExcludes: [ClientRole],
			views: [
				{
					path: `${eeModule.ee}/${eeModule.base}`,
					name: 'Scorecards',
					mini: 'SC',
					Component: EmploymentEquityBase,
					layout: portal,
				},
				{
					path: `${eeModule.ee}/${eeModule.documentRepo}`,
					name: 'Document Repository',
					mini: 'DR',
					Component: DocumentRepoBasePage,
					componentProps: {
						documentRepoSectionModuleType:
							DocumentRepoSectionModuleTypes.EE_Module,
					},
					layout: portal,
				},
				{
					path: `${eeModule.ee}/${eeModule.groupImports}`,
					name: 'Group Imports',
					mini: 'GI',
					Component: GroupImportsBase,
					userRoleIncludes: [EE123PeopleRole_Edit, EE123SalariesRole],
					layout: portal,
				}
			],
		},
		{
			path: wspModule.wsp,
			name: 'WSP/ATR Module',
			icon: 'nc-icon nc-briefcase-24',
			Component: ComingSoonPage,
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'wspCollapse',
			userRoleExcludes: [ClientRole, VAUser],
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			views: [
				{
					path: `${wspModule.wsp}/${wspModule.base}`,
					name: 'Scorecards',
					mini: 'SC',
					Component: WSPScorecardPage,
					layout: portal,
				}
			],
		},
		{
			path: 'home',
			name: 'Scorecard Licenses',
			icon: 'nc-icon nc-paper',
			Component: ScorecardLicenseMain,
			layout: portal,
			isExternal: false,
			userRoleIncludes: [ClientRole],
			visible: config.enable_react_migration === 'true',
		}
	]
};

export const VerificationCompanyRoutes = (isApplicationSelected: boolean): ProtectedRoute[] => {
	return [
		{
			name: 'Details',
			icon: 'nc-icon nc-bullet-list-67',
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'CompanyDetailsCollapse',
			views: [
				{
					path: `${verificationAgency.company}/${verificationAgency.details}/company`,
					name: 'Company Details',
					mini: 'CD',
					Component: DetailsBase,
					layout: portal,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.details}/contacts`,
					name: 'Contacts',
					mini: 'CT',
					Component: DetailsBase,
					layout: portal,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.details}/refferedBy`,
					name: 'Referred By',
					mini: 'RB',
					Component: DetailsBase,
					layout: portal,
				},
			],
		},
		{
			path: `${verificationAgency.company}/${verificationAgency.applications}/clientApplications`,
			name: 'Applications',
			icon: 'nc-icon nc-delivery-fast',
			layout: portal,
			isExternal: false,
			collapse: false,
			hasChildren: false,
			Component: VerificationAgencyClientApplicationPage,
		},
		{
			name: 'Application Information',
			icon: 'nc-icon nc-bullet-list-67',
			layout: portal,
			isExternal: false,
			collapse: true,
			hasChildren: true,
			state: 'CompanyApplicationCollapse',
			visible: isApplicationSelected,
			views: [
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/serviceRequired`,
					mini: 'SR',
					name: 'Service Required',
					Component: ServiceRequired,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/financialInformation`,
					name: 'Financial Information',
					mini: 'FI',
					Component: FinancialInformationDetails,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/beeCommisioner`,
					name: 'BEE Commissioner',
					mini: 'BC',
					Component: CommisionerDetails,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/proposals`,
					name: 'Proposals',
					mini: 'PR',
					Component: Proposals,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/${verificationAgency.feedback}`,
					name: 'Feedback',
					mini: 'FB',
					Component: FeedbackBase,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/${verificationAgency.riskAssessment}`,
					name: 'Risk Assessment',
					mini: 'RA',
					Component: RiskAssessment,
					layout: portal,
					visible: isApplicationSelected,
				},
				{
					path: `${verificationAgency.company}/${verificationAgency.applications}/${verificationAgency.status}`,
					name: 'Status',
					mini: 'ST',
					Component: Status,
					layout: portal,
					visible: isApplicationSelected,
				},
			],
		},
		{
			path: `${verificationAgency.company}/${verificationAgency.scorecards}`,
			name: 'Scorecards',
			icon: 'nc-icon nc-credit-card',
			Component: VAClientScorecards,
			layout: portal,
			isExternal: false,
		},
	];
};

export const VerificationRoutes: ProtectedRoute[] = [
	{
		path: 'home',
		name: 'Home',
		icon: 'nc-icon nc-app',
		Component: VerificationHomePage,
		layout: portal,
		isExternal: false,
	},
	{
		name: 'Client Relationship Management',
		icon: 'nc-icon nc-badge',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'verificationHomeCollapse',
		views: [
			{
				path: `${verificationAgency.clientManagement}/clients`,
				name: 'Clients',
				mini: 'CL',
				Component: ClientManagementBase,
				layout: portal,
			},
			{
				path: `${verificationAgency.clientManagement}/applications`,
				name: 'Applications',
				mini: 'AP',
				Component: ClientManagementBase,
				layout: portal,
			},
			{
				path: `${verificationAgency.clientManagement}/documentRepository`,
				name: 'Document Repository',
				mini: 'DR',
				Component: ClientManagementBase,
				layout: portal,
			},
			{
				path: `${verificationAgency.clientManagement}/certificateRegistry`,
				name: 'Certificate Registry',
				mini: 'CR',
				Component: ClientManagementBase,
				layout: portal,
			},
			{
				path: `${verificationAgency.clientManagement}/notifications`,
				name: 'Notifications',
				visible: config.enable_notification_settings === 'true',
				mini: 'NT',
				Component: ClientManagementBase,
				layout: portal,
			},
		],
	},
	{
		path: 'mainVerificationExternal',
		name: 'Scorecard Management',
		icon: 'nc-icon nc-paper',
		Component: `${config.publicUrl}#myBEE123VerificationHomepage/scorecardManagement`,
		layout: portal,
		isExternal: true,
		visible: config.enable_react_migration === 'false',
	},
	{
		path: 'bbeeModule',
		name: 'B-BBEE Module',
		icon: 'nc-icon nc-paper',
		layout: portal,
		isExternal: true,
		collapse: true,
		state: 'bbbeeModuleCollapse',
		visible: config.enable_react_migration === 'true',
		views: [
			{
				path: `${vaBBBEEmodule.scorecardManagement}`,
				name: 'Scorecard Management',
				mini: 'SM',
				Component: VAOpenScorecardHomepage,
				collapse: true,
				state: 'ScorecardManagementCollapse',
				layout: portal,
				visible: config.enable_react_migration === 'true',
				views: [
					{
						path: `${vaBBBEEmodule.scorecardManagement}/OpenScorecard`,
						name: 'Open Scorecards ',
						mini: 'OS',
						state: 'OpenScorecard',
						Component: VAOpenScorecardHomepage,
						layout: portal,
					},
					{
						path: `${vaBBBEEmodule.scorecardManagement}/LockedScorecard`,
						name: 'Locked Scorecards ',
						mini: 'LS',
						state: 'LockedScorecard',
						Component: VALockedScorecardHomepage,
						layout: portal,
					},
				],
			},
			{
				path: `${vaBBBEEmodule.administrator}`,
				name: 'Administrator',
				mini: 'AD',
				Component: VAMethodologyHomePage,
				collapse: true,
				state: 'AdministratorCollapse',
				layout: portal,
				visible: config.enable_react_migration === 'true',
				userRoleIncludes: [UserAdminRole, SubAdminRole, AuditRole],
				userRoleExcludes: [ScorecardAdmin, ClientAdminRole, ClientRole],
				views: [
					{
						path: `${vaBBBEEmodule.administrator}/VaMethodology`,
						name: 'VA Methodology ',
						mini: 'VM',
						Component: VAMethodologyHomePage,
						layout: portal,
					},
					{
						path: `${vaBBBEEmodule.administrator}/SampleMethodology`,
						name: 'Sample Methodology',
						mini: 'SM',
						Component: SampleMethodologyHomepage,
						layout: portal,
					}
				],
			},
			{
				path: `${vaBBBEEmodule.incoming}`,
				name: 'Incoming',
				mini: 'IN',
				Component: IncomingBasePage,
				collapse: true,
				state: 'IncomingCollapse',
				layout: portal,
				visible: config.enable_VAIntegrationSubmissionProcess === 'true',
				userRoleExcludes: [ScorecardAdmin],
				views: [
					{
						path: `${vaBBBEEmodule.incoming}/scorecardSubmissions`,
						name: 'Scorecard Submissions',
						mini: 'SS',
						Component: IncomingBasePage,
						visible: config.enable_VAScorecardSubmissionProccess === 'true',
						layout: portal,
					},
					{
						path: `${vaBBBEEmodule.incoming}/${vaBBBEEmodule.dataPageSubmissions}`,
						name: 'Data Page Submissions',
						mini: 'DS',
						Component: IncomingBasePage,
						layout: portal,
					},
					{
						path: `${vaBBBEEmodule.incoming}/${vaBBBEEmodule.accessRequests}`,
						name: 'Access Requests',
						mini: 'AR',
						Component: IncomingBasePage,
						layout: portal,
					},
				],
			},
		],
	},
];

export const ConstantRoutes = (hasWSPScorecards: boolean, hasActiveBEELicenses: boolean, hasActiveEELicenses: boolean): ProtectedRoute[] => {
	return [
		{
			path: eeModule.academy,
			name: 'Academy',
			icon: 'nc-icon nc-hat-3',
			Component: AcademyBasePage,
			layout: portal,
			isExternal: false,
			state: 'Academy',
			collapse: true,
			views: [
				{
					path: eeModule.academy + '/digitalContent',
					name: 'Digital Content',
					mini: 'DC',
					Component: AcademyBasePage,
					layout: portal,
				},
				{
					path: eeModule.academy + '/webinars',
					name: 'Training Webinars',
					mini: 'TW',
					Component: AcademyBasePage,
					layout: portal,
				},
				{
					path: eeModule.academy + '/publicEvents',
					name: 'Public Events',
					mini: 'PE',
					Component: AcademyBasePage,
					layout: portal,
				}
			],
		},
		{
			path: 'beeForum',
			name: 'The Forum',
			icon: 'nc-icon nc-bank',
			Component: BEEForum,
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'forumCollapse',
			userRoleExcludes: [ClientRole],
			views: [
				// {
				//    path: "beeForum",
				//    name: "Chat Room",
				//    mini: "CR",
				//    Component: BEEForum,
				//   layout: portal
				// },
				// {
				//     path: "beeForum",
				//     name: "B-BBEE",
				//     mini: "BF",
				//     Component: BEEForum,
				//     layout: portal,
				//     subLevel: true
				// },
				// {
				//     path: `${eeModule.ee}/${eeModule.forum}`,
				//     name: "EE Forum",
				//     mini: "EF",
				//     Component: EEForum,
				//     layout: portal,
				//     subLevel: true
				// },
				{
					path: 'news',
					name: 'News',
					mini: 'NW',
					Component: NewsBase,
					layout: portal,
				},
				{
					path: 'whatsNew',
					name: 'Updates',
					mini: 'WN',
					Component: WhatsNewPage,
					layout: portal,
				},
				{
					path: `${eeModule.legislation}`,
					name: 'Legislation & Resources',
					mini: 'LE',
					Component: BeeLegislationResourcesPage,
					layout: portal,
					state: 'Legislation',
					collapse: true,
					visible: hasActiveBEELicenses || hasActiveEELicenses,
					views: [
						{
							path: `${eeModule.legislation}/B-BBEE`,
							name: 'B-BBEE',
							mini: 'BB',
							Component: BeeLegislationResourcesPage,
							layout: portal,
							visible: hasActiveBEELicenses
						},
						{
							path: `${eeModule.legislation}/EE`,
							name: 'Employment Equity',
							mini: 'EE',
							state: 'EE',
							Component: EELegislationResourcesPage,
							layout: portal,
							visible: hasActiveEELicenses
						},
						{
							path: `${eeModule.legislation}/WSPATR`,
							name: 'WSP/ATR',
							mini: 'WA',
							Component: WspAtrLegislationResourcesPage,
							visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
							layout: portal,
						},
					],
				},
				//BEE Directories
				{
					path: `Directories/`,
					name: 'BEE Directories',
					mini: 'BD',
					Component: '/',
					layout: ExternalMain,
					isExternal: true,
					visible: config.enable_react_migration === 'true',
					state: 'BEEDirectories',
					collapse: true,
					views: [
						{
							path: `main`,
							name: 'The BEE123 Suppliers Directory',
							mini: 'BD',
							Component: config.publicUrl + '#supplierDirectory',
							layout: ExternalMain,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
						{
							path: `sed-directory/`,
							name: 'The BEE123 SED Directory',
							mini: 'BD',
							Component: 'https://www.bee123.co.za/sed-directory/',
							layout: ExternalMain,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						}
					],
				},
				//Solutions
				{
					path: `Solutions/`,
					name: 'Solutions',
					mini: 'SL',
					Component: '/',
					layout: ExternalMain,
					isExternal: true,
					state: 'Solutions',
					collapse: true,
					visible: config.enable_react_migration === 'true',
					views: [
						{
							path: `bee123-management-software/`,
							name: 'BEE Software',
							mini: 'BS',
							Component: 'https://www.bee123.co.za/bee123-management-software/',
							layout: ExternalMain,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
						{
							path: `esd123/`,
							name: 'ESD123',
							mini: 'ES',
							Component: 'https://www.bee123.co.za/esd123-2/',
							layout: ExternalMain,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
						{
							path: `skills123/`,
							name: 'Skills123',
							mini: 'SK',
							Component: 'https://www.bee123.co.za/skills123-2/',
							layout: portal,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
						{
							path: `yes123/`,
							name: 'YES123',
							mini: 'YE',
							Component: 'https://www.bee123.co.za/yes123-5/',
							layout: portal,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
						{
							path: `sed123/`,
							name: 'SED123',
							mini: 'SE',
							Component: 'https://www.bee123.co.za/sed123/',
							layout: portal,
							isExternal: true,
							visible: config.enable_react_migration === 'true',
						},
					],
				},
			],
		},
	]
};

export const AccountRoute: AccountRoutes[] = [
	{
		path: 'account',
		iconClass: 'sidebar-mini-icon',
		className: 'sidebar-normal',
		MenuAbv: 'MP',
		MenuItemName: 'My Profile',
		Component: AccountPage,
		layout: portal,
	},
	{
		path: 'userManagement',
		iconClass: 'sidebar-mini-icon',
		className: 'sidebar-normal',
		MenuAbv: 'UM',
		MenuItemName: 'User Management',
		Component: UserManagementBase,
		layout: portal,
		userRoleIncludes: [UserAdminRole, SubAdminRole, ClientAdminRole, ScorecardAdmin],
	},
	{
		path: 'supportTickets',
		iconClass: 'sidebar-mini-icon',
		className: 'sidebar-normal',
		MenuAbv: 'ST',
		MenuItemName: 'Support Tickets',
		Component: SupportTickets,
		layout: portal
	},
	{
		path: 'userActivityTracking',
		iconClass: 'sidebar-mini-icon',
		className: 'sidebar-normal',
		MenuAbv: 'UA',
		MenuItemName: 'User Activity Tracking',
		Component: UserActivityTracking,
		layout: portal,
		userRoleIncludes: [UserAdminRole],
	},
];

export const AllNotesRoute: ProtectedRoute[] = [
	{
		path: eeScorecard.notes + '/:noteId/',
		name: 'Notes',
		icon: 'nc-icon nc-single-copy-04',
		Component: AllNotesPage,
		layout: portal,
		isExternal: false,
	},
];

export const OFOCodesCategorisationRoute = (hasWSPScorecards: boolean): ProtectedRoute[] => {
	return [
		{
			path: wspModule.Dashboard,
			name: 'Dashboard',
			icon: 'nc-icon nc-chart-pie-36',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: WSPDashboardBasePage,
			layout: portal,
			isExternal: false,
			collapse: false
		},
		{
			path: wspModule.OrganisationDetails,
			name: 'Organisation Details',
			icon: 'nc-icon nc-box-2',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: OganisationDetailsPage,
			layout: portal,
			isExternal: false,
			collapse: false
		},
		{
			path: wspModule.OFOCodesCategorisation,
			name: 'OFO Codes Categorisations',
			icon: 'nc-icon nc-bag-16',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: OFOCodesCategorisationPage,
			layout: portal,
			isExternal: false,
			collapse: false,
		},
		{
			path: wspModule.WorkforceProfile + '/previewReport',
			name: 'Workforce Profile Report',
			icon: 'nc-icon nc-tablet-2',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: WorkforceProfilePage,
			layout: portal,
			isExternal: false,
			collapse: false
		},
		{
			path: `${wspModule.MerSETAReport}/ATRReport`,
			name: 'ATR Report',
			icon: 'nc-icon nc-single-copy-04',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: MerSETAReport,
			layout: portal,
			isExternal: false,
			collapse: false
		},
		{
			path: `${wspModule.MerSETAReport}/WSPReport`,
			name: 'WSP Report',
			icon: 'nc-icon nc-single-copy-04',
			visible: config.enable_WSPATR === 'true' || hasWSPScorecards,
			Component: MerSETAReport,
			layout: portal,
			isExternal: false,
			collapse: false
		},
	]
}

export const OrganisationRoute = (isOrganisationSelected: boolean, hasWSPScorecards: boolean, showPayrollIntegrationMenuItems: boolean): ProtectedRoute[] => {
	return [
		{
			path: organisationModule.people,
			name: 'People',
			icon: 'nc-icon nc-single-02',
			visible: (config.enable_WSPATR === 'true' || hasWSPScorecards) && isOrganisationSelected && !showPayrollIntegrationMenuItems,
			Component: OrganisationPeoplePage,
			layout: portal,
			isExternal: false,
			collapse: false,
			userRoleIncludes: [PlatformPeopleViewRole, PlatformPeopleEditRole, UserAdminRole]
		},
		{
			path: organisationModule.training,
			name: 'Training',
			icon: 'nc-icon nc-ruler-pencil',
			visible: (config.enable_WSPATR === 'true' || hasWSPScorecards) && isOrganisationSelected && !showPayrollIntegrationMenuItems,
			Component: OrganisationTraining,
			layout: portal,
			isExternal: false,
			collapse: true,
			views: [
				{
					path: organisationModule.training + '/External',
					name: 'External',
					mini: 'EX',
					Component: OrganisationTraining,
					layout: portal
				},
				{
					path: organisationModule.training + '/Internal',
					name: 'Internal',
					mini: 'IN',
					Component: OrganisationTraining,
					layout: portal
				},
				{
					path: organisationModule.training + '/LAI',
					name: 'LAIs',
					mini: 'L',
					Component: OrganisationTraining,
					layout: portal,
				}
			]
		},
		{
			path: organisationModule.payrollConnections,
			name: 'Payroll Connections',
			icon: 'nc-icon nc-single-02',
			Component: PayrollConnections,
			layout: portal,
			isExternal: false,
			visible: showPayrollIntegrationMenuItems,
			userRoleIncludes: [UserAdminRole, SubAdminRole]
		},
		{
			path: organisationModule.linkedScorecards,
			name: 'Linked Scorecards',
			icon: 'nc-icon nc-ruler-pencil',
			Component: OrganisationLinkedScorecards,
			layout: portal,
			isExternal: false,
			visible: showPayrollIntegrationMenuItems,
			userRoleIncludes: [UserAdminRole, SubAdminRole]
		},
		{
			path: organisationModule.divisions,
			name: 'Divisions',
			icon: 'nc-icon nc-ruler-pencil',
			Component: Divisions,
			layout: portal,
			isExternal: false,
			visible: false
		},
		{
			path: organisationModule.payrollData,
			name: 'Payroll Imports',
			icon: 'nc-icon nc-single-copy-04',
			Component: PayrollRequests,
			layout: portal,
			isExternal: false,
			collapse: true,
			visible: showPayrollIntegrationMenuItems,
			views: [
				{
					path: organisationModule.payrollData + '/fetchData',
					name: 'Fetch Data',
					mini: 'FD',
					Component: PayrollRequests,
					layout: portal
				},
				{
					path: organisationModule.payrollData + '/importHistory',
					name: 'Import History',
					mini: 'IH',
					Component: PayrollImportHistory,
					layout: portal
				},
				{
					path: organisationModule.payrollImportDetails + '/:scorecardId/:importDetailsId/:useSignalR',
					name: 'Payroll Import Details',
					mini: 'ID',
					Component: ImportDetails,
					layout: portal,
					isExternal: false,
					visible: false
				}
			]
		}
	]
};

export const EEScorecardRoutes: ProtectedRoute[] = [
	{
		path: eeScorecard.dashboard,
		name: 'Dashboard',
		icon: 'nc-icon nc-chart-pie-36',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'DashboardCollapse',
		views: [
			{
				path: `${eeScorecard.dashboard}/${eeScorecard.employeeHeadcountDashboard}`,
				name: 'Employee Headcount',
				mini: 'ES',
				Component: DashboardBasePage,
				layout: portal,
			},
			{
				path: `${eeScorecard.dashboard}/${eeScorecard.incomeDifferentialsDashboard}`,
				name: 'Income Differentials',
				mini: 'ES',
				Component: DashboardBasePage,
				layout: portal,
				userRoleIncludes: [EE123SalariesRole],
			},
			{
				path: `${eeScorecard.dashboard}/${eeScorecard.eePlanTrackingDashboard}`,
				name: 'EE Plan Tracking',
				mini: 'EP',
				Component: DashboardBasePage,
				layout: portal,
			},
		],
	},
	{
		path: eeScorecard.generalInformation,
		name: 'General Information',
		icon: 'nc-icon nc-single-copy-04',
		Component: GeneralInformation,
		layout: portal,
		isExternal: false,
	},
	{
		path: eeScorecard.consolidation,
		name: 'Consolidation',
		icon: 'nc-icon nc-single-copy-04',
		Component: Consolidation,
		layout: portal,
		isExternal: false,
		isConsolidatedRoute: true,
	},
	{
		name: 'Employee Structure',
		icon: 'nc-icon nc-vector',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'EmployeeStructureCollapse',
		views: [
			{
				path: eeScorecard.employeeStructure,
				name: 'Employee Structure',
				mini: 'ES',
				Component: EmployeeStructureBasePage,
				layout: portal,
			},
			{
				path: eeScorecard.employeeSalaries,
				name: 'Employee Salaries',
				mini: 'ES',
				Component: EmployeeStructureBasePage,
				layout: portal,
				userRoleIncludes: [EE123SalariesRole],
			},
		],
	},
	{
		name: 'Employment Equity Plan',
		icon: 'nc-icon nc-map-big',
		layout: portal,
		isExternal: false,
		state: 'EmployeeEquityPlanCollapse',
		collapse: true,
		views: [
			{
				path: eeScorecard.eePlan + '/Objectives',
				name: 'Objectives',
				mini: 'O',
				Component: EEPlan,
				layout: portal,
			},
			{
				path: eeScorecard.eePlan + '/Barriers',
				name: 'Barriers and Affirmative Action Measures',
				mini: 'BA',
				Component: EEPlan,
				layout: portal,
			},
			{
				path: eeScorecard.eePlan + '/WorkforceProfileGoalsAndTargets',
				name: 'Workforce Profile, Numerical Goals and Targets',
				mini: 'WP',
				Component: EEPlan,
				layout: portal,
			},
			{
				path: eeScorecard.eePlan + '/Additional',
				name: 'Additional',
				mini: 'AD',
				Component: EEPlan,
				layout: portal,
			}
		],
	},
	{
		name: 'Workforce Profile (EEA2)',
		icon: 'nc-icon nc-badge',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'WorkforceProfileCollapse',
		views: [
			{
				path: eeScorecard.workforceProfile + '/WorkforceProfile',
				name: 'Workforce Profile',
				mini: 'WP',
				Component: EEA2Base,
				layout: portal,
			},
			{
				path: eeScorecard.workforceProfile + '/Movements',
				name: 'Movements',
				mini: 'M',
				Component: EEA2Base,
				layout: portal,
			},
			{
				path: eeScorecard.workforceProfile + '/SkillsDevelopment',
				name: 'Skills Development',
				mini: 'SD',
				Component: EEA2Base,
				layout: portal,
			},
			{
				path: eeScorecard.workforceProfile + '/MonitoringAndEvaluation',
				name: 'Monitoring & Evaluation',
				mini: 'ME',
				Component: EEA2Base,
				layout: portal,
			},
		],
	},
	{
		name: 'Remuneration (EEA4)',
		icon: 'nc-icon nc-money-coins',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'RenumarationCollapse',
		userRoleIncludes: [EE123SalariesRole],
		views: [
			{
				path: eeScorecard.remuneration + '/Remuneration',
				name: 'Remuneration',
				mini: 'SC',
				Component: EEA4Base,
				layout: portal,
			},
			{
				path: eeScorecard.remuneration + '/MedianRemunerationAndRemunerationGap',
				name: 'Median Remuneration and the Remuneration Gap',
				mini: 'P',
				Component: EEA4Base,
				layout: portal,
			},
		],
	},
	{
		name: 'EE Committee',
		icon: 'nc-icon nc-shop',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'EECommitteeCollapse',
		views: [
			{
				path: eeScorecard.eeCommittee + '/Members',
				name: 'Members',
				mini: 'ME',
				Component: CommitteeBase,
				layout: portal,
			},
			{
				path: eeScorecard.eeCommittee + '/Minutes',
				name: 'Minutes',
				mini: 'MI',
				Component: CommitteeBase,
				layout: portal,
			},
		],
	},
	{
		path: eeScorecard.eeaReporting,
		visible : !(config.enable_new_EE_Reporting_Dashboards === 'true'),
		name: 'Reporting',
		icon: 'nc-icon nc-chart-bar-32',
		Component: EEReportingBase,
		layout: portal,
		isExternal: false,
	},
	{
		name: 'Reporting',
		visible : config.enable_new_EE_Reporting_Dashboards === 'true',
		icon: 'nc-icon nc-chart-bar-32',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'ReportingCollapse',
		views: [
			{
				path: eeScorecard.reporting + '/EEA',
				name: 'EEA Reporting',
				mini: 'ER',
				Component: ReportBase,
				layout: portal,
			},
			{
				path: eeScorecard.reporting + '/DashboardReports' , 
				name: 'Dashboard Reporting',
				mini: 'DR',
				Component: ReportBase,
				layout: portal,
			},
		],
		
	},
];

export const BBBEEScorecardRoutes: ProtectedRoute[] = [
	{
		name: 'Summary',
		icon: 'nc-icon nc-chart-pie-36',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'SummaryCollapse',
		views: [
			{
				path: `${bbbeeScorecardRoute}summary/dashboard`,
				name: 'Dashboard',
				mini: 'DB',
				Component: LegacyBEEPage,
				componentProps: {
					legacyRoute: 'scorecard/{ScorecardId}/dashboard',
					elementName: 'Summary',
					pageTitle: 'Dashboard'
				},
				layout: portal,
			},
			{
				path: `${bbbeeScorecardRoute}summary/scorecard`,
				name: 'Scorecard',
				mini: 'SC',
				Component: LegacyBEEPage,
				componentProps: {
					legacyRoute: 'scorecard/{ScorecardId}/summary',
					elementName: 'Summary',
					pageTitle: 'Scorecard'
				},
				layout: portal,
			},
			{
				path: `${bbbeeScorecardRoute}summary/notes`,
				name: 'Notes',
				mini: 'NT',
				Component: LegacyBEEPage,
				componentProps: {
					legacyRoute: 'notes/{ScorecardId}',
					elementName: 'Summary',
					pageTitle: 'Notes'
				},
				layout: portal,
			},
		],
	},
	{
		name: 'Verification Process',
		icon: 'nc-icon nc-paper',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'VerificationProcessCollapse',
		visible: config.enable_VAIntegrationSubmissionProcess === 'true',
		userRoleExcludes: [AuditRole],
		views: [
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}`,
				name: 'Planner & Tracker',
				mini: 'PT',
				Component: VerificationProcessBase,
				layout: portal,
			},
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.verificationProcess}/${bbbeeModule.elements}`,
				name: 'Elements',
				mini: 'EL',
				Component: VerificationProcessBase,
				layout: portal,
			}
		],
	},
	{
		name: 'Scorecard Outcome',
		icon: 'nc-icon nc-tile-56',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'ScorecardOutcomeCollapse',
		userRoleIncludes: [ClientAdminRole, UserAdminRole],
		views: [
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.reports}`,
				name: 'Reports',
				mini: 'RE',
				Component: Reports,
				layout: portal,
			},
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.certificates}`,
				name: 'Certificates',
				mini: 'CE',
				Component: Certificates,
				layout: portal,
			},
		]
	},
	{
		name: 'Import Management',
		icon: 'nc-icon nc-vector',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'ImportManagementCollapse',
		visible: config.enable_VA_client_excel_import === "true",
		userRoleExcludes: [ScorecardAdmin],
		views: [
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.fileManagement}`,
				name: 'File Management',
				mini: 'FM',
				Component: FileManagementBase,
				layout: portal,
				isExternal: false,
			},
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.importPage}`,
				name: 'Import Data',
				mini: 'ID',
				Component: MultiPageImport,
				layout: portal,
				isExternal: false,
			},
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.importManagementHistory}`,
				name: 'Import History',
				mini: 'IH',
				Component: ImportManagementHistory,
				layout: portal,
				isExternal: false,
			},
			{
				path: `${bbbeeScorecardRoute}${bbbeeModule.importDetails}/:importDetailsId/:useSignalR`,
				name: 'Import Details',
				mini: 'ID',
				Component: ImportDetails,
				layout: portal,
				isExternal: false,
				visible: false
			},
		]
	},
];

export const BEEHubRoutes = (userRegistrationId: string): ProtectedRoute[] => {
	return [
		{
			name: 'BEE123 Hub',
			icon: 'nc-icon nc-paper',
			layout: portal,
			isExternal: false,
			collapse: true,
			state: 'AdvisoryCollapse',
			visible: config.advisory_registration_id.toLocaleLowerCase() === userRegistrationId.toLocaleLowerCase(),
			views: [
				{
					path: advisoryModule.clientRegistrations,
					name: 'Client Registrations',
					mini: 'CR',
					Component: ClientRegistrations,
					layout: portal,
					userRoleIncludes: [BEEAdvisoryRole, EEAdvisoryRole, AdvancedSupplierModuleRole, StrategicRelationshipManagerRole]
				},
				{
					path: `main`,
					name: 'Site Admin',
					mini: 'SA',
					Component: config.publicUrl,
					layout: portal,
					userRoleIncludes: [SiteAdminRole],
					isExternal: true
				}
			],
		}
	]
};

export const BEE123RegistrationRoutes: ProtectedRoute[] = [
	{
		name: 'B-BBEE',
		icon: 'nc-icon nc-chart-pie-36',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'ClientBEECollapse',
		userRoleIncludes: [BEEAdvisoryRole, EEAdvisoryRole, AdvancedSupplierModuleRole, StrategicRelationshipManagerRole],
		views: [
			{
				path: advisoryModule.clientBEEScorecards,
				name: 'Scorecards',
				mini: 'SC',
				Component: ClientScorecards,
				layout: portal,
				userRoleIncludes: [BEEAdvisoryRole, EEAdvisoryRole, AdvancedSupplierModuleRole, StrategicRelationshipManagerRole],
			},
		],
	},
	{
		name: 'EE',
		icon: 'nc-icon nc-chart-pie-36',
		layout: portal,
		isExternal: false,
		collapse: true,
		state: 'ClientEECollapse',
		userRoleIncludes: [BEEAdvisoryRole, EEAdvisoryRole, StrategicRelationshipManagerRole],
		views: [
			{
				path: advisoryModule.clientEEScorecards,
				name: 'Scorecards',
				mini: 'SC',
				Component: ClientScorecards,
				layout: portal,
				userRoleIncludes: [BEEAdvisoryRole, EEAdvisoryRole, StrategicRelationshipManagerRole],
			},
		],
	},
];